import { useStyles } from "./ImageChooser.style";
import {
  RoundedImageChooser,
  RoundedImageChooserProps,
} from "./components/rounded-image-chooser/RoundedImageChooser";
import {
  SquareImageChooser,
  SquareImageChooserProps,
} from "./components/square-image-chooser/SquareImageChooser";

export type VariantTypes = "rounded" | "square";

export interface ImageChooserProps {
  variant?: VariantTypes;
}

export const ImageChooser = (
  props: ImageChooserProps | RoundedImageChooserProps | SquareImageChooserProps
) => {
  const classes = useStyles(props);
  // @ts-ignore
  const { variant } = props;

  return (
    <div className={classes.root}>
      {variant === "rounded" ? (
        <RoundedImageChooser {...props} />
      ) : (
        <SquareImageChooser {...props} />
      )}
    </div>
  );
};

ImageChooser.defaultProps = {
  variant: "rounded",
};
